/*  Copyright (C) 2020 OhmConnect, Inc. - All Rights Reserved  */
import {useLocation} from 'react-router-dom';

export default function useQuery() {
  return new URLSearchParams(useLocation().search);
}
